export const tr = {
    'display-href-description':
        'Gösterilen bağlantı, site sayfasının reklamda gösterilecek adresidir. Kolayca okunabilen ve kullanıcıların reklama tıkladıktan sonra hangi sayfaya geçiş yapacaklarını kolayca anlamalarını sağlayacak bir bağlantı kullanmanızı öneririz.',
    'normal-view-title': 'Gösterilen bağlantıları reklamlara ekleyin',
    'normal-view-title-hint': 'Bağlantıların gösterilmediği reklamlarınız olduğu için bu öneriyi görüyorsunuz',
    'popup-view-title': 'Gösterilen bağlantıyı reklama ekleyin',
    'popup-view-title-hint': 'Reklamda bağlantı gösterilmediği için bu öneriyi görüyorsunuz',
    'show-many-banner-button': '{count} reklamı görüntüle',
    'show-one-banner-button': '{count} reklamı görüntüle',
    'show-some-banner-button': '{count} reklamı görüntüle'
};
